export const ClassTypeLabel = ({
  liveStreamClass,
  isVideo,
  isCustom,
}: {
  liveStreamClass?: boolean;
  isVideo?: boolean;
  isCustom?: boolean;
}) => {
  const label = isVideo
    ? "ON-DEMAND"
    : liveStreamClass
    ? "ONLINE"
    : isCustom
    ? "MANUAL"
    : "PRESENCIAL";

  let baseClasses = "rounded-md text-xs text-center px-3 py-1 inline-flex items-center justify-center w-28";
  let conditionalClasses = "";

  if (liveStreamClass || isVideo) {
    conditionalClasses = "bg-holos-dark text-white";
  } else {
    conditionalClasses = "bg-holos-light text-black";
  }

  return <div className={`${baseClasses} ${conditionalClasses}`}>{label}</div>;
};